module.exports = __webpack_public_path__ + "img/triangle.b999c5e5.png";